import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * CanonicalLink Component
 * Dynamically adds canonical link tags to prevent duplicate content issues
 *
 * @param {Object} props
 * @param {string} props.baseUrl - Base URL of the site (default: https://whatsnew.vercel.app)
 */
const CanonicalLink = ({ baseUrl = 'https://whatsnew.vercel.app' }) => {
  const location = useLocation();

  useEffect(() => {
    // Remove existing canonical link if any
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }

    // Create canonical URL (ignore query params to avoid duplicate content)
    const canonicalUrl = `${baseUrl}${location.pathname}`;

    // Add new canonical link
    const link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', canonicalUrl);
    document.head.appendChild(link);

    // Cleanup on unmount - use cached reference instead of querying DOM again
    return () => {
      if (link.parentNode) {
        link.remove();
      }
    };
  }, [location.pathname, baseUrl]);

  return null; // This component doesn't render anything
};

export default CanonicalLink;
